import { render, staticRenderFns } from "./PayrollDetailsReportView.vue?vue&type=template&id=30f08c4a&scoped=true&"
import script from "./PayrollDetailsReportView.vue?vue&type=script&lang=ts&"
export * from "./PayrollDetailsReportView.vue?vue&type=script&lang=ts&"
import style0 from "./PayrollDetailsReportView.vue?vue&type=style&index=0&id=30f08c4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f08c4a",
  null
  
)

export default component.exports